var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"diviseur",class:_vm.couleur},[_vm._v(_vm._s(_vm.titre))]),_c('DiviseurLogo',{staticClass:"logo"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }